import { useLocation } from 'react-router';
import StepBar from '../components/StepBar';
import { DESTINATIONS } from '../lib/destinations';

/**
 * Every navigation item the onboarding half of the spec promises, before the
 * marketplace half is built. It says what is coming rather than apologising.
 */
export default function Soon() {
  const location = useLocation();
  const key = location.pathname.replace(/^\//, '');
  const destination = DESTINATIONS[key];

  if (!destination) {
    return (
      <>
        <StepBar left="Not found" right="Nothing here" />
        <h1 className="d">No such page.</h1>
        <p className="sub">Use the navigation above.</p>
      </>
    );
  }

  return (
    <>
      <StepBar left={destination.title} right="In production" />
      <h1 className="d">{destination.title}</h1>
      <p className="sub">{destination.blurb}</p>

      <div className="stack">
        {destination.points.map(point => (
          <div key={point} className="panel">
            <p style={{ color: 'var(--fg)' }}>{point}</p>
          </div>
        ))}
      </div>

      <div className="rule" />
      <p className="mono">This section is being built. Your profile is what it will use when it lands.</p>
    </>
  );
}
